<template>
  <div class="dingdan">
    <!--        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单列表(内销)'}]" v-if="firstPageFlag!=1"/>-->
    <Breadtabsheader />
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
              <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
            </el-form-item>
            <el-form-item label="　创建人编码/名称" prop="cuserCodeNameLike">
              <el-input v-model="formInline.cuserCodeNameLike" placeholder="请输入" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="　订单类型" prop="orderCategory1">
              <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in orderCategory1List" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="自产 /OEM" prop="prodtype">
                  <el-select v-model="formInline.prodtype" :clearable="true" placeholder="请选择">
                    <el-option label="自产" value="自产"></el-option>
                    <el-option label="OEM" value="OEM"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
                  <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入" style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item label="订单状态" prop="status">
                  <brselect clearable category="order_status" :v="formInline.status" v-model="formInline.status"></brselect>
                </el-form-item>
                <el-form-item label="销售组织" prop="saleGroupCode">
                  <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true" v-model="formInline.saleGroupCode" clearable></brselect>
                </el-form-item>
              </div>
              <div class="h-thirdColumn w-newColumn">
                <!--
                                <el-form-item label="订单类型" prop="orderCategory">
                                    <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                            v-model="formInline.orderCategory" clearable
                                        @change="changeOrderCate"
                                    ></brselect>
                                </el-form-item>
                                -->
                <el-form-item label="　　是否手动收货" v-auth="'caiwushouhuo'" prop="shouhuoflag">
                  <brselect clearable category="shifou_keyong" :v="formInline.shouhuoflag" v-model="formInline.shouhuoflag"></brselect>
                </el-form-item>
                <el-form-item label="创建时间" prop="cdatebegin" style="width: 50%;">
                  <el-date-picker v-model="formInline.cdatebegin" clearable type="date" value-format="yyyy-MM-dd">
                  </el-date-picker>
                  <span class="w-time-to">至</span>
                  <el-date-picker v-model="formInline.cdateend" clearable type="date" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="　产品编码/名称" prop="materialCodeNameLike">
                  <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="是否血站订单" prop="isBlood">
                  <brselect clearable category="shifou_keyong" :v="formInline.isBlood" v-model="formInline.isBlood"></brselect>
                  <!-- <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input> -->
                </el-form-item>
                <el-form-item label="签收状态" prop="prodtype">
                  <el-select v-model="formInline.thawStatus" :clearable="true" placeholder="请选择">
                    <el-option label="已签收" value="Y"></el-option>
                    <el-option label="未签收" value="N"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="共享大类" prop="shareModelCode">
                  <brselect :v="formInline.shareModelCode" category="product_level" v-model="formInline.shareModelCode" clearable placeholder="请选择"></brselect>
                </el-form-item>
                <el-form-item prop="ownShenpiFlag" class="clstyle">
                  <el-switch v-model="formInline.ownShenpiFlag" active-text="只看我的审批" inactive-text="查看所有" @change="ownShenpiFlag()">
                  </el-switch>
                </el-form-item>

              </div>

              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="分销商订单号" prop="secondSapCode" style="width: 50%;">
                  <el-input v-model="formInline.secondSapCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="分销商编码/名称" prop="secondLevelAgentLike">
                  <el-input v-model="formInline.secondLevelAgentLike" placeholder="请输入" style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item label="直销/分销" prop="disChannelCode">
                  <el-select v-model="formInline.disChannelCode" :clearable="true">
                    <el-option label="直销" value="Z1"></el-option>
                    <el-option label="分销" value="00"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>

          <!-- <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                                @click="imgfalse3" v-if="firstPageFlag!=1">
                            新建订单
                        </el-button>
                        <el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
                                @click="caiwushouhuo">
                            收货
                        </el-button>
                    </div> -->
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="imgfalse3" v-if="firstPageFlag!=1">
              新建订单
            </el-button>
            <el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen" @click="caiwushouhuo">
              收货
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-mrt30 margin">
      <!--            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">每月的最后一天中午12点至次日凌晨4点为系统禁止签收时间，不可进行签收操作！</h6>-->
      <!--            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">2022年4月签收截止日期为4月29日中午12点,请及时签收！</h6>-->
    </div>
    <div class="h-table h-mrt30 tableclslist">
      <el-table ref="ddtable" :data="tableData" :span-method="objectSpanMethod" @selection-change="handleSelectionChange" stripe border :show-overflow-tooltip="true" style="width: 100%" max-height="450">
        <el-table-column type="selection" fixed width="40">
        </el-table-column>
        <el-table-column type="index" width="40" label="#" fixed>
        </el-table-column>
        <el-table-column fixed prop="sapCode" label="订单号" :show-overflow-tooltip="true" width="120">
        </el-table-column>
        <el-table-column prop="soldToName" label="售达方名称" fixed :show-overflow-tooltip="true" width="180">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.soldToName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" label="产品名称" fixed :show-overflow-tooltip="true" width="140">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.materialName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="oemDesc" label="规格型号" width="140" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="proNumber" label="数量" width="60">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.proNumber}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" :show-overflow-tooltip="true" min-width="180">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.note}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prodtype" label="自产/OEM" width="100">
          <template scope="scope">
            <div style="text-align: left;" v-if="scope.row.gscode != '1R60' || adminFlag">
              {{scope.row.prodtype}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spbmjcmtlgroupname" label="开票名称" width="240" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="shareModelName" label="共享大类" width="100">
          <template scope="scope">
            <div style="text-align: center;">
              {{scope.row.shareModelName}}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="isZhidan" label="经销商类型" :show-overflow-tooltip="true" width="110">
          <template scope="scope">
            {{scope.row.isZhidan|dictname('dailishang_leixing')}}
          </template>
        </el-table-column>

        <el-table-column prop="secondLevelAgentName" label="分销商名称" :show-overflow-tooltip="true" width="120">
        </el-table-column>

        <el-table-column prop="secondSapCode" label="分销商订单号" width="100">
        </el-table-column>
        <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="110">
        </el-table-column>
        <el-table-column prop="status" label="订单状态" :show-overflow-tooltip="true" width="110">
          <template scope="scope">
            {{scope.row.status|dictname('order_status')}}
          </template>
        </el-table-column>

        <el-table-column prop="orderCategory" label="订单类型" :show-overflow-tooltip="true" width="100">
          <template scope="scope">
            {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
          </template>
        </el-table-column>
        <el-table-column prop="sid" label="特价版本号" :show-overflow-tooltip="true" width="180">
        </el-table-column>
        <el-table-column prop="saleGroupCode" label="销售组织" :show-overflow-tooltip="true" width="260">
          <template scope="scope">
            <div style="text-align: left;">
              [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="soldToCode" label="售达方编码" :show-overflow-tooltip="true" width="110">
        </el-table-column>

        <el-table-column prop="soldToAreaName" label="售达方地区" :show-overflow-tooltip="true" width="110">
        </el-table-column>
        <!--<el-table-column-->
        <!--prop="currencyCode"-->
        <!--label="币种编码"-->
        <!--width="110">-->
        <!--</el-table-column>-->
        <el-table-column prop="disChannelCode" label="分销渠道编码" :show-overflow-tooltip="true" width="130">
          <template scope="scope">
            {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
          </template>
        </el-table-column>
        <el-table-column prop="customerChannelCode" label="客户渠道" :show-overflow-tooltip="true" width="90">
          <template scope="scope">
            {{scope.row.customerChannelCode|dictname('sales_region')}}
          </template>
        </el-table-column>
        <el-table-column prop="orderProjectName" label="项目名称" :show-overflow-tooltip="true" width="180">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.orderProjectName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cuname" label="创建人名称" :show-overflow-tooltip="true" width="110">
        </el-table-column>
        <el-table-column prop="cdate" label="创建时间" width="160">
        </el-table-column>

        <el-table-column prop="toCompanyname" label="收货单位" :show-overflow-tooltip="true" width="180">
          <template scope="scope">
            <div style="text-align: left;">
              {{scope.row.toCompanyname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contactName" label="收货联系人" width="110">
        </el-table-column>

        <!--<el-table-column-->
        <!--prop="wldw"-->
        <!--label="单位"-->
        <!--width="70">-->
        <!--</el-table-column>-->
        <el-table-column prop="finalPrice" label="成交价" :show-overflow-tooltip="true" width="80">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.finalPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalprice" label="总价" :show-overflow-tooltip="true" width="80">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.totalprice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="jinejjz" label="不含税总价" :show-overflow-tooltip="true" width="110">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.jinejjz}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalprice" label="汇算总价" :show-overflow-tooltip="true" width="90">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.totalprice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="acceptTime" label="签收时间" :show-overflow-tooltip="true" width="100">
        </el-table-column>
        <el-table-column prop="thawStatus" label="签收状态" :show-overflow-tooltip="true" width="60">
          <template scope="scope">
            <span v-if="scope.row.thawStatus == 'Y'">已签收</span>
            <span v-if="scope.row.thawStatus == 'N'">未签收</span>
          </template>
        </el-table-column>
        <el-table-column prop="priceType" label="费用名称" width="120" :show-overflow-tooltip="true">
          <template scope="scope">
            {{scope.row.priceType|dictname('price_type') }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="260">
          <template slot-scope="scope">
            <div style="text-align: left;">
              <div v-if="scope.row.status == '10'" style="text-align: left;">
                <el-button v-if="_user.usercode == scope.row.cucode || adminFlag" size="small" class="h-tableLink h-btn" @click="handleEdit(scope.row)">编辑
                </el-button>
                <el-button v-if="_user.usercode == scope.row.cucode || adminFlag" size="small" class="h-tableLink h-btn" @click="sapDeleteOrder2(scope.row)">删除
                </el-button>
                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-xg" title="编辑订单" @click="handleEdit(scope.row)"></span>
                                    <span class="l-operationlist br-operation-delete" title="删除订单" @click="sapDeleteOrder2(scope.row)"></span>
                                </div> -->
              </div>
              <div v-else style="text-align: left;">
                <el-button v-if=" (scope.row.status == '43'
                                            || (scope.row.status == '41' && scope.row.add1 != 'A' &&  scope.row.add1 != 'D' )) && is1S00 && (scope.row.gscode == '1S00' || scope.row.gscode == '1S40' || scope.row.gscode == '1S30')" size="small" class="h-tableLink h-btn" @click="submitSapPass(scope.row)">
                  批准通过
                </el-button>
                <el-button v-if="scope.row.binstid" size="small" class="h-tableLink h-btn" @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
                <el-button size="small" class="h-tableLink h-btn" @click="handelDetail(scope.row)">查看
                </el-button>
                <el-button size="small" class="h-tableLink h-btn" v-if="(scope.row.gscode=='1S00' || scope.row.gscode=='1S40') && (scope.row.status == '50' || scope.row.status == '42') && scope.row.thawStatus == 'N' && (hhgaijia || adminFlag)" @click="onChangePrice(scope.row)">改价
                </el-button>
                <!--<el-button-->
                <!--v-if="scope.row.status < 50"-->
                <!--size="small" class="h-tableLink h-btn"-->
                <!--v-auth="'zuofeidingdan'"-->
                <!--@click="sapDeleteOrder(scope.row)">作废-->
                <!--</el-button>-->

                <el-button v-if="scope.row.status == 30" size="small" class="h-tableLink h-btn" @click="sapDeleteOrder2(scope.row)">删除
                </el-button>
                <el-button v-if="_user.usercode == scope.row.cucode && scope.row.status == 20 || ((scope.row.gscode == '1S00' || scope.row.gscode == '1S40') && scope.row.status == 50 && scope.row.factory == '1S00')" size="small" class="h-tableLink h-btn" @click="sapCHOrder(scope.row)">撤回
                </el-button>
                <!--                                <el-button-->
                <!--                                        v-if="scope.row.isAccept == 1 && scope.row.orderCategory1 == '9' && scope.row.thawStatus == 'N' &&jueseFlag && isDateFlag"-->
                <!--                                        size="small" class="h-tableLink h-btn"-->
                <!--                                        @click="updateBillBlkFw(scope.row)">签收-->
                <!--                                </el-button>-->
                <!--                                <el-button-->
                <!--                                        v-if="scope.row.fwFjStatus == 1"-->
                <!--                                        size="small" class="h-tableLink h-btn"-->
                <!--                                        @click="seeFile(scope.row)">查看附件-->
                <!--                                </el-button>-->
                <span v-if="_user.usercode == scope.row.cucode">
                  <el-button v-if="scope.row.shenpiflag" size="small" class="h-tableLink h-btn" @click="shenpiopt(scope.row, '1')">
                    提报
                  </el-button>
                </span>
                <span v-if="_user.usercode == scope.row.cucode && scope.row.status == '50' && scope.row.orderCategory1 == '8' && scope.row.zltype === '3'">
                  <el-button size="small" class="h-tableLink h-btn" @click="handleEditZl(scope.row)">
                    编辑
                  </el-button>
                </span>
                <span v-else>
                  <el-button v-if="scope.row.shenpiflag" size="small" class="h-tableLink h-btn" @click="shenpiopt(scope.row, '')">
                    审批
                  </el-button>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
        <pagination :page="formInline" @query="query" />
        <div style="display:flex;align-items: center;">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
          </el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入
          </el-button>

          <el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'allSP'" icon="h-el-icon h-el-icon-export" @click="allSP">批量审批
          </el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="el-icon-copy-document" v-auth="'createxiaoshoucontract'" @click="createHTXS">生成销售合同
          </el-button>
          <!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem" v-if="isDateFlag"-->
          <!--                               @click="uploadYsFile">批量上传签收资料-->
          <!--                    </el-button>-->
        </div>
        <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="viewOrderImportExcel" :startrow="3" @callback="uploadExcelFilecallback" />
      </div>
    </div>

    <!--附件管理-->
    <el-dialog :visible.sync="showFujian" v-if="showFujian" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>订单凭证总览</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;overflow: scroll">
        <h3>报关单</h3>
        <h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
        <brupload style="margin-top: 0.1rem;" @filecallback="fjStatus(fjCode)" :refid="refid" reftype="WXFJ_BGD" :uploadflag="fjFlag" delflag />
      </div>
      <div class="h-formLine" style="padding:20px;overflow: scroll">
        <h3>入货通知</h3>
        <h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
        <brupload style="margin-top: 0.1rem;" @filecallback="fjStatus(fjCode)" :refid="refid" reftype="WXFJ_RHTZ" :uploadflag="fjFlag" delflag />
      </div>
      <div class="h-formLine" style="padding:20px;overflow: scroll">
        <h3>提单</h3>
        <h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">开具发票后开放上传</h6>
        <brupload style="margin-top: 0.1rem;" :refid="refid" reftype="WXFJ_TD" :uploadflag="fjFlag" delflag />
      </div>
    </el-dialog>
    <!--创建订单弹出框-->
    <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false" />

    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />

    <el-dialog :close-on-click-modal="false" title="作废订单" :visible.sync="zfyydialogFormVisible">
      <el-form :model="zuofeiyy">
        <el-form-item label="作废原因" :label-width="100">
          <brselect category="DD_ZFYY" :v="zuofeiyy.yy" v-model="zuofeiyy.yy"></brselect>
        </el-form-item>
        <el-form-item label="备注" :label-width="100">
          <el-input type="textarea" :rows="3" resize="none" v-model="zuofeiyy.bz" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="撤回订单" :visible.sync="chehuidialogFormVisible">
      <el-form :model="zuofeiyy">
        <el-form-item label="撤回原因" :label-width="100">
          <brselect category="DD_ZFYY" :v="zuofeiyy.yy" v-model="zuofeiyy.yy"></brselect>
        </el-form-item>
        <el-form-item label="备注" :label-width="100">
          <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
        </el-form-item>
        <div v-if="!this.guanliren">
          <el-form-item label="撤单申请书" class="h-elformWrap-2">
            <!-- :rules="[
                { required: true, message: '请上传撤单申请书', trigger: 'change'},
                ]" -->
            <brupload :refid="refid" reftype="订单-撤单申请书" :limit="1" :showtime="false" uploadflag delflag>
            </brupload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="chehui">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="order.showOrderNxSp" v-if="order.showOrderNxSp" v-on="$listeners" :modal-append-to-body='false' append-to-body :close-on-click-modal="false" title="内销订单" width="90%" class="showflowDialogcls">
      <ordernxsp @refreshSelf="refreshSelf" :orderid="order.orderid" :orderinstid="order.orderinstid" :ordertaskid="order.ordertaskid" :ordertaskstatus="order.ordertaskstatus" />
    </el-dialog>

    <!--批量审批-->
    <el-dialog :visible.sync="showAllSP" v-if="showAllSP" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>订单批量审批确认</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">订单号:</h3>
        <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <el-form :model="spform" label-position="right" :inline="true" class="demo-ruleForm h-formbLine qlplshyj">
          <el-form-item label="审批意见" class="h-elformWrap-1 " style="margin-bottom: 0;" :required="true">
            <el-input v-model="spform.shpyj" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn h-bgred" @click="saveOrSubmit(2)">驳 回</el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(1)">通 过</el-button>
      </div>
    </el-dialog>
    <!--附件管理-批量上传入货通知-->
    <el-dialog :visible.sync="showFwkaipiao" v-if="showFwkaipiao" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>内销服务订单解冻签收凭证总览</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">订单号:</h3>
        <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
        <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应签收资料，单据以“订单号+单据名称”命名，以上信息完整方可开票</h6>
      </div>
      <div class="h-formLine" style="padding:20px;">
        <h3 style="display: inline-block;">签收资料</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload style="margin-top: 0.1rem;" @filecallback="DJKPStatus" :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')" reftype="NXFW_QSZL" :uploadflag="fjFlag" :delflag="!(this.ks == 'Y')" />
      </div>
      <!--            <div class="h-formLine" style="width:200px;padding:20px;">
                <h3 style="display: inline-block;">签收时间</h3>
                <el-date-picker
                        v-model="date1"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>-->
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
      </div>
    </el-dialog>
    <!--附件管理-查看/下载全部附件-->
    <el-dialog :visible.sync="showFujianD" v-if="showFujianD" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>订单签收资料</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
        <h3 style="display: inline-block;">订单号:</h3>
        <h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhU}}</h4>
        <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请准确上传对应签收资料，单据以“订单号+单据名称”命名，以上信息完整方可开票</h6>
      </div>
      <div class="h-formLine" style="padding:20px;">
        <h3 style="display: inline-block;">签收资料</h3>
        <h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
        <brupload style="margin-top: 0.1rem;" @filecallback="DJKPStatus" :refid="refid" reftype="NXFW_QSZL" :uploadflag="fjFlag" :delflag="!(this.ks == 'Y')" />
      </div>
      <div class="h-formLine" style="width:200px;padding:20px;">
        <h3 style="display: inline-block;">签收时间</h3>
        <el-date-picker v-model="date1" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../api/SystemService'
import updownfile from '../../utils/updownfile'
import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
export default {
  props: ["firstPageFlag"],
  components: {
    uploaddownexcel,
  },
  data () {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      //导入Excel
      uploaddownexcelflag: false,

      fjFlag: null,
      fjCode: null,
      fhStatus: null,
      refid: null,
      reftype: null,
      showFujian: null,
      showFwkaipiao: null,
      showFujianD: null,
      isDateFlag: false,
      kaipiao: {
        id: null,
        acceptTime: null,
        sapCode: null,
      },
      ddhU: '',
      ddhB: '',
      ddhK: '',
      ddhI: '',
      showAllSP: null,
      spform: {
        ywid: null,
        taskid: null,
        optflag: null,
        shpyj: null,
      },

      instid: null,
      showhistory: null,
      adminFlag: false,
      imgflag3: false,
      is1S00: false,
      orderTypeList: [],
      orderCategory1AllList: [],
      orderCategory1List: [],
      jueseFlag: false,
      hhgaijia:false,
      tableData: [],
      //用户项目
      allProjectByUser: [],
      //是否有项目
      xiangmuTab: false,
      //销售组织，下拉
      xszz: [],
      fxqd: [],
      //表单
      formInline: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        ownShenpiFlag: false,
        ownShenpi: '',
        cuserCodeNameLike: "",
        sdfCodeNameLike: "",
        materialCodeNameLike: "",
        orderCategory: "",
        saleGroupCode: "",
        status: "",
        cdatebegin: null,
        cdateend: null,
        orderTypebz: 1,
        shouhuoflag: null,
        isBlood: '',
        prodtype: null,
        isAccept: '',
        thawStatus: '',
        secondLevelAgentLike: "",
        secondSapCode: "",
        disChannelCode: '',
      },
      fujian: {
        id: null,
        acceptTime: null,
        sapCode: null,
      },
      spanArr: [],
      //作废原因
      zfyydialogFormVisible: false,
      //撤回
      chehuidialogFormVisible: false,
      zuofeiyy: {
        id: null,
        yy: null,
        bz: null,
      },

      tableSelectedList: [],

      order: {
        showOrderNxSp: false,
        showOrderWxSp: false,
        orderid: "",
        orderinstid: "",
        ordertaskid: "",
        ordertaskstatus: "",
      },
      multipleSelection: [],
      guanliren: false
    }
  },

  created () {
    this.query();
    this.isDate();
    if (this.$store.getters.hasRole('swyl-fuwu')) {
      this.jueseFlag = true;
    }
    if (this.$store.getters.hasRole('hh_shichangneiqin,hh_caiwu')) {
      this.hhgaijia = true;
    }
    this.adminFlag = this.$store.getters.hasRole('swyl_admin');
    this.nxddgyl = this.$store.getters.hasRole('swyl_dingdgly');
    if (this.nxddgyl) {
      this.formInline.ownShenpiFlag = true;
      this.formInline.ownShenpi = 1;
    }
    if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('hh_caiwu')) {
      this.is1S00 = true;
    }
    this.orderCategory1AllList = this.$store.getters.dictlist("xiaoshou_quyu_nwx");
    this.orderCategory1List = _.filter(this.orderCategory1AllList, { pid: '201910254L3O3bAL' });

    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl");

    //    项目
    //     this.listPro();
  },
  methods: {
    // 展开折叠
    collapseChange () {
      this.isScreen = !this.isScreen;
    },
    refreshSelf (params) {
      if (params && params.close) {
        this.order.showOrderNxSp = false;
      }
      if (params && params.refresh) {
        this.query();
      }
    },
    //导入Excel
    uploaddownexcelflagbtn () {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback (rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },

    changeOrderCate (cate) {
      if (cate) {
        this.orderCategory1List = _.filter(this.orderCategory1AllList, { pid: cate.id });
        console.log(cate.id);
      } else {
        this.orderCategory1List = [];
      }

    },
    shenpiopt (row, flag) {
      console.log(333, row)
      // /dingdmain/orderNxshenpi?taskid=20200106Cqk3e32f&ywid=2020010699cc510c&instid=20200106tqw7ZYOm&taskstatus=0
      var instid = null;
      if (row.orderCategory == '1') {
        instid = row.binstid;
      } else {
        instid = row.instid;
      }
      // this.$router.push({
      //     path: row.dburl,
      //     query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
      // })
      if (flag == "1") {
        if (row.funnelCode != undefined && row.funnelCode != "") {
          // 订单关联漏斗重新提交
          this.$router.push({
            path: "/dingd/createNxOrder3",
            query: { ywid: row.bid, taskid: row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag, funnelCode3: row.funnelCode }
          })
          return;
        } else {
          this.$router.push({
            path: row.dburl,
            query: { ywid: row.bid, taskid: row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag }
          })
          return;
        }
      }
      this.order.orderid = row.bid;
      this.order.orderinstid = instid;
      this.order.ordertaskstatus = '0';
      this.order.ordertaskid = row.taskid;
      this.order.showOrderNxSp = true;
      return;
      // let routeData = this.$router.resolve({
      //     path: row.dburl,
      //     query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
      // });
      // window.open(routeData.href, '_blank');
    },
    //批量导出
    exportExcel () {
      var strids = _.join(_.map(this.tableSelectedList, "bid"), ",");
      var form = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        ownShenpiFlag: false,
        ownShenpi: '',
        cuserCodeNameLike: "",
        sdfCodeNameLike: "",
        materialCodeNameLike: "",
        orderCategory: "",
        saleGroupCode: "",
        status: "",
        cdatebegin: null,
        cdateend: null,
        orderTypebz: 1,
        shouhuoflag: null,
        prodtype: null,
      };
      if (strids == '') {
        form = _.clone(this.formInline);
      }
      form.strids = strids;
      updownfile.down("/api/swyl/v1/demo/viewOrder/downloadExcel", form, "post");
    },

    //批量审批
    allSP () {
      if (this.ddhB == '') {
        this.$msg.msge("请勾选要执行审批的订单!!!");
        return false;
      }
      var flag1 = false
      this.tableSelectedList.forEach((item, index) => {
        if (item.shenpiflag != true) {
          flag1 = true;
          return;
        }
      })
      if (flag1) {
        this.$msg.msge("包含无审批权限的订单,请重新选择!");
        return;
      }
      this.showAllSP = true;
    },
    /**
     * 生成销售合同
     */
    createHTXS () {
      console.log(this.multipleSelection);
      ss.OrderMainService.createHTXS(this.multipleSelection).then(rd => {
        this.$msg.alerts("创建成功！", "提示");
      })
    },
    handleSelectionChange (lists) {
      this.tableSelectedList = lists;
      this.multipleSelection = lists;
      var str = '';
      var yw = '';
      var task = '';
      for (var i = 0; i < lists.length; i++) {
        str += lists[i].sapCode + ',';
        yw += lists[i].bid + ',';
        task += lists[i].taskid + ',';
      }
      str = str.substring(0, str.length - 1);
      yw = yw.substring(0, yw.length - 1);
      task = task.substring(0, task.length - 1);
      this.ddhB = str;
      this.ddhI = yw;
      this.ddhK = task;
    },

    cancel () {
      this.showAllSP = false;
      this.chehuidialogFormVisible = false;
      this.zfyydialogFormVisible = false;
      this.showFwkaipiao = false;
      this.zuofeiyy = {
        id: null,
        yy: null,
        bz: null,
      };
    },

    saveOrSubmit (v) {
      this.spform.ywid = this.ddhI;
      this.spform.taskid = this.ddhK;
      if (v == '2') {
        this.spform.optflag = '驳回';
        console.log('shpyj', this.spform.shpyj);
        if (!this.spform.shpyj) {
          this.$msg.msge("驳回必须输入审批意见！");
          return;
        }
      } else if (v == '1') {
        this.spform.optflag = '通过'
      }
      var confirmMsg = "确认提交?";
      this.$msg.confirm(confirmMsg, () => {
        this.submitForm();
      })
      this.showAllSP = false;
    },

    submitForm () {
      ss.OrderMainService.allSP(this.spform).then(rd => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          this.$emit('refreshSelf', { close: true, refresh: true });
          this.query();
          return;
        })
      })
    },

    ownShenpiFlag () {
      if (this.formInline.ownShenpiFlag) {
        this.formInline.ownShenpi = '1';
      } else {
        this.formInline.ownShenpi = '';
      }
      console.log('我在这儿呀', this.formInline.ownShenpi);
    },

    //财务收货
    caiwushouhuo () {
      console.log(this.tableSelectedList)
      if (this.tableSelectedList.length == 0) {
        this.$msg.msge("至少选中一条操作！");
        return false;
      }
      var shlist = [];
      for (var i = 0; i < this.tableSelectedList.length; i++) {
        var obj = this.tableSelectedList[i];

        if (obj.status != '50') {
          this.$msg.msge("选中的订单状态不对，只有已发货的才能执行收货操作！");
          return false;
        } else {
          shlist.push(obj);
        }
      }
      ss.OrderMainService.updateShouhuoflag(_.join(_.map(shlist, "bid"), ",")).then(rd => {
        this.$refs['ddtable'].clearSelection();
        this.$msg.msgs("更新收货状态成功！");
        this.query();
      })
    },

    //附件管理
    opendia (o) {
      this.fjFlag = o.status < 50 ? false : true;
      this.fjCode = o.sapCode;
      this.fhStatus = o.status;
      console.log('我在这儿呀', o.status);
      this.refid = o.sapCode;
      this.showFujian = true;
    },
    fjStatus (x) {
      ss.OrderMainService.updateFjStatus(x).then(rd => {
      });
    },

    getSpanArr () {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData[index].id === this.tableData[index - 1].id) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (
        (column.property == 'orderCategory')
        ||
        (column.property == 'soldToCode')
        ||
        (column.property == 'soldToName')
        ||
        (column.property == 'disChannelCode')
        ||
        (column.property == 'orderProjectName')
        ||
        (column.property == 'customerChannelCode')
        ||
        (column.property == 'soldToAreaName')
        ||
        (column.property == 'toCompanyname')
        ||
        (column.property == 'contactName')
        ||
        (column.property == 'cuname')
        ||
        (column.property == 'cdate')
        ||
        (
          (column.label == '订单状态' || column.label == '操作') &&
          (row.status == '10')
        )
        ||
        (
          (column.label == '操作') &&
          (row.orderCategory == '3')
        )
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    genzongLiuch (r) {
      console.log(r);
      if (r.orderCategory == '1' || r.orderCategory == '3') {
        this.instid = r.binstid;
      } else {
        this.instid = r.instid;
      }
      this.showhistory = true;
    },
    imgfalse3 () {
      this.imgflag3 = true;
    },
    //查询该用户及所有子用户所有订单详情
    query () {
      ss.OrderMainService.selectDingdanPage(this.formInline).then(rd => {
        this.tableData = rd.records;
        this.formInline.total = rd.total || 0;
        this.getSpanArr();
      });
    },

    //检索
    handleFilter () {
      this.formInline.pageNo = 1;
      this.query();
    },

    /*            //冲销
                updateBillBlkFw(x) {
                    var sapCodes = [];
    /!*                this.tableSelectedList.forEach((item, index) => {
                        this.kaipiao.id = item.id;
                        this.kaipiao.acceptTime = item.acceptTime;
                        sapCodes.push(this.kaipiao)
                    })*!/
                    this.kaipiao.id = x.id;
                    this.kaipiao.acceptTime = x.acceptTime;
                    this.kaipiao.sapCodes = x.sapCodes;
                    sapCodes.push(this.kaipiao)
                    this.$msg.confirm("确认签收?", () => {
                        ss.OrderMainService.updateBillBlk(sapCodes).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                },*/


    // 重置按钮
    resetData () {
      this.formInline.sapCode = "";
      this.formInline.ownShenpiFlag = false;
      this.formInline.ownShenpi = "";
      this.formInline.cuserCodeNameLike = "";
      this.formInline.sdfCodeNameLike = "";
      this.formInline.materialCodeNameLike = "";
      this.formInline.orderCategory = "";
      this.formInline.orderCategory1 = "";
      this.formInline.saleGroupCode = "";
      this.formInline.status = "";
      this.formInline.cdatebegin = null;
      this.formInline.cdateend = null;
      this.formInline.orderTypebz = 1;
      this.formInline.shouhuoflag = null;
      this.formInline.prodtype = null;
      this.formInline.isBlood = '';
      this.formInline.thawStatus = '';
      this.query();
    },

    //判断当前日期是否在允许签收的时间范围之内
    isDate () {
      ss.OrderMainService.isDate().then(rd => {
        this.isDateFlag = rd.msg;
      })
    },


    handleEdit (row) {
      console.log(row)
      if (row.orderCategory1 == '9' && (row.orderCategory2 == '5' || row.orderCategory2 == '6')) {
        //服务订单
        this.$router.push({ path: "/dingd/createMfFuwuOrder", query: { id: row.id } })
        return;
      }
      this.toEdit(row.orderCategory, row.orderCategory1, row.id, row.funnelCode);
      // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
    },
    handleEditZl (row) {
      console.log(row)
      if (row.zltype == '3') {
        this.$router.push({ path: "/dingd/createNxOrder", query: { id: row.bid, zltype: row.zltype } })
      } else {
        this.toEdit(row.orderCategory, row.orderCategory1, row.id);
      }
      // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
    },
    handelDetail (row) {
      var instid = null;
      if (row.orderCategory == '1') {
        instid = row.binstid;
      } else {
        instid = row.instid;
      }
      if (row.orderCategory == '1') {
        this.order.orderid = row.bid;
        this.order.orderinstid = instid;
        this.order.ordertaskstatus = '1';
        this.order.showOrderNxSp = true;
        return;
      } else {
        this.$router.push({
          path: "/dingdmain/orderShshenpi",
          query: { id: row.bid, instid: instid, taskstatus: '1', f: '1' }
        });
      }
    },
    // 改价
    onChangePrice(row){
      var instid = null;
      if (row.orderCategory == '1') {
        instid = row.binstid;
      } else {
        instid = row.instid;
      }
      if (row.orderCategory == '1') {
        this.order.orderid = row.bid;
        this.order.orderinstid = instid;
        this.order.ordertaskstatus = '3';
        this.order.showOrderNxSp = true;
        return;
      }
    },

    //作废订单
    sapDeleteOrder (row) {
      if (row.status == '10') {
        this.$msg.confirm("确认作废?", () => {
          ss.OrderMainService.sapDeleteOrder(row.bid, row.deleteReason).then(rd => {
            this.$msg.msgs(rd.msg);
            this.query();
          });
        });
      } else {
        this.zuofeiyy.id = row.bid
        this.zfyydialogFormVisible = true;
      }
    },

    //删除订单
    sapDeleteOrder2 (row) {
      // if (row.status == '10' || row.status == '30' || row.status == '70') {
      if (row.status == '10' || row.status == '30') {
        this.$msg.confirm("确认删除?", () => {
          ss.OrderMainService.sapDeleteOrder2(row.bid, row.deleteReason).then(rd => {
            this.$msg.msgs(rd.msg);
            this.query();
          });
        });
      } else {
        this.zuofeiyy.id = row.bid
        this.zfyydialogFormVisible = true;
      }
    },

    submitzuofei () {
      if (!this.zuofeiyy.yy) {
        this.$msg.msge("请选择作废原因");
        return false;
      }
      var yybz = this.zuofeiyy.yy + ":" + this.$store.getters.dictname("DD_ZFYY", this.zuofeiyy.yy) + ":" + this.zuofeiyy.bz;
      this.$msg.confirm("确认作废?", () => {
        ss.OrderMainService.sapDeleteOrder(this.zuofeiyy.id, yybz).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
          this.zfyydialogFormVisible = false;
          this.zuofeiyy = {
            id: null,
            yy: null,
            bz: null,
          };
        });
      });
    },
    //撤回订单
    sapCHOrder (row) {
      this.$msg.confirm("确认从SAP作废并撤回订单?", () => {
        this.zuofeiyy.id = row.bid
        this.chehuidialogFormVisible = true;
        this.refid = row.bid;
      });
    },
    chehui () {
      if (!this.zuofeiyy.yy) {
        this.$msg.msge("请选择撤回原因");
        return false;
      }
      var yybz = this.zuofeiyy.yy + ":" + this.$store.getters.dictname("DD_ZFYY", this.zuofeiyy.yy) + ":" + this.zuofeiyy.bz;
      this.$msg.confirm("确认撤回?", () => {
        ss.OrderMainService.sapCHOrder(this.zuofeiyy.id, yybz).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
          this.chehuidialogFormVisible = false;
          this.zuofeiyy = {
            id: null,
            yy: null,
            bz: null,
          };
        });
      });
    },
    toEdit (ddlx, ddzlx, id, funnelCode) {
      if (ddlx == '1') {
        if (ddzlx == '9') {
          //服务订单
          this.$router.push({ path: "/dingd/createFuwuOrder", query: { id: id } })
          return;
        }
        if (ddzlx == '14') {
          //退货订单
          this.$router.push({ path: "/dingd/createNxThOrder", query: { id: id } })
          return;
        }
        if (ddzlx == '15') {
          //组合订单
          this.$router.push({ path: "/dingd/createCombinationOrder", query: { id: id } })
          return;
        }
        if (funnelCode != undefined && funnelCode != "") {
          // 订单关联漏斗编辑页面
          this.$router.push({ path: "/dingd/createNxOrder3", query: { id: id, funnelCode3: funnelCode } })
        } else {
          this.$router.push({ path: "/dingd/createNxOrder", query: { id: id } })
        }
      } else if (ddlx == '2') {
        //外销
        if (ddzlx == '25') {
          //服务订单
          this.$router.push({ path: "/dingd/createWxFuwuOrder", query: { id: id } })
          return;
        }
        this.$router.push({ path: "/dingd/createWxOrder", query: { id: id } })
        return;
      } else {
        //上海直销
        this.$router.push({ path: "/dingd/createShanghOrder", query: { id: id } })
      }
    },
    submitSapPass (value) {
      var data = {};
      data.id = value.id;
      data.sapCode = value.sapCode;
      ss.OrderMainService.submitOrderSapPassHhnx(data).then(rd => {
        this.$msg.msgs("推送成功！")
        this.query();
      })
    },
    /*//批量上传入货单
    uploadYsFile() {
        if(this.ddhB == ''){
            this.$msg.msge("请勾选以上订单!!!");
            return false;
        }
        var flag1 = false
        var flag2 = false
        var flag3 = false
        var orderTypeChild = this.tableSelectedList[0].orderCategory1;
        this.tableSelectedList.forEach((item, index) => {
            if(item.status < 40){
                flag1 = true;
                return;
            }
            if(!(item.orderCategory1 == '9')){
                flag2 = true;
                return;
            }
            if(item.orderCategory1 != orderTypeChild){
                flag3 = true;
                return;
            }
        })

        if(flag1){
            this.$msg.msge("审核通过后的正常订单才能上传签收资料,请重新选择!");
            return;
        }
        if(flag2){
            this.$msg.msge("只有内销服务订单才能上传签收资料,请重新选择!");
            return;
        }
        if(flag3){
            this.$msg.msge("只能选择同一类型的订单！");
            return;
        }
        this.fjFlag = true;
        this.tableSelectedList.forEach((item, index) => {
            if(item.status < 50 && (item.orderCategory2 == '5' || item.orderCategory2 == '6')){
                this.fjFlag = false;
            }
            if(item.thawStatus == 'Y'){
                this.ks = 'Y';
            }else{
                this.ks = 'N';
            }
        })
        this.date1 = new Date();
        this.showFwkaipiao = true;
    },
    DJKPStatus() {
        var ids = [];
        var form = {};
        var obj = null;
        for(var i = 0;i < this.tableSelectedList.length;i++){
            this.tableSelectedList[i].acceptTime = this.date1;
            var obj = this.tableSelectedList[i];
            ids.push(obj);
            console.log('ids', obj);
        }
        ss.OrderMainService.updateKpStatus(ids).then(rd => {
        });
    },

    submitFujianC() {
        var flag3 = false
        var sapCodes = []
        for (var i = 0; i < this.tableSelectedList.length; i++) {
            this.tableSelectedList[i].acceptTime = this.date1;
            var obj = this.tableSelectedList[i];
            sapCodes.push(obj);
        }

        ss.OrderMainService.DingdToSap(sapCodes).then(rd => {
            if (rd.f == true) {
                this.$msg.msgs("解冻开票成功！");
                this.query();
                this.showFwkaipiao = false;
            }
        });
    },
    seeFile(o) {
        this.fjFlag = o.status < 50 ? false : true;
        this.fjCode = o.sapCode;
        // this.id = o.id;
        this.fhStatus = o.status;
        this.bS = o.billingStatus;
        this.refid= this.ddhU = o.sapCode;
        this.fujian.id = o.id;
        this.fujian.sapCode = o.sapCode;
        this.fujian.acceptTime = o.acceptTime;
        if(o.thawStatus == 'Y'){
            this.ks = 'Y'
        }else{
            this.ks = 'N'
        }
        this.date1 = o.acceptTime;
        this.showFujianD = true;
    },*/

    handleDelete (row) {

    },
    //导出Excel
    /*downloadExcel() {

        var idlist = [];
        this.multipleSelection.forEach(element => {
            idlist.push(element.pid);
        });

        this.q.ids = idlist;
        this.q.orderCategory = this.formInline.orderCategory;
        this.q.orderType = this.formInline.orderType;
        this.q.cucode = this.formInline.cucode;
        this.q.cunameLike = this.formInline.cunameLike;
        this.q.saleGroupCode = this.formInline.saleGroupCode;
        this.q.orderStatus = this.formInline.orderStatus;

        updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

    },*/

  },

  mounted () {

  },

}
</script>
<style scoped>
.xiangmu .h-piece,
.h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}
.tableclslist .h-tableLink {
  padding: 0px 2px !important;
}
</style>
<style>
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label {
  width: 20%;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content {
  width: 80%;
}
</style>
